<template>
  <v-row>
    <v-container fluid>
      <v-row>
        <span class="font-weight-black text-h6 mt-8 ml-10">
          <v-avatar size="31" tile class="mb-1">
            <v-img src="../../assets/chevron-left.svg"></v-img>
          </v-avatar>{{user.name}}</span>
      </v-row>
      <v-row>
        <v-col lg="10" sm="6" xs="6">
          <v-tabs class="mt-4">
            <v-tab class="font-weight-bold" @click="setUserTopicsTab()">投稿トピック</v-tab>
            <v-tab class="font-weight-bold" @click="setPublicRelationsTab()">PR</v-tab>
          </v-tabs>
        </v-col>
        <v-col lg="2" sm="6" xs="6">
          <template v-if="isFavorited">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="isAuth && !isMyPage && isFavorited" 
                  @click="userFavorite"
                  :outlined="favoriteBtnOutLine"
                  :color="favoriteBtnColor"
                  xs="x-small"
                  sm="x-small"
                  lg="x-small"
                  :loading="userFavoritedLoading"
                  class="font-weight-bold mt-6"
                  v-on="on"
                  v-bind="attrs"
                >
                  <span class="font-weight-bold">フォロー中</span>
                </v-btn>
              </template>
              <span>フォローを解除する</span>
            </v-tooltip>
          </template>
          <template else>
            <v-btn
              v-if="isAuth && !isMyPage && !isFavorited" 
              @click="userFavorite"
              :outlined="favoriteBtnOutLine"
              :color="favoriteBtnColor"
              xs="x-small"
              sm="x-small"
              lg="x-small"
              :loading="userFavoritedLoading"
              class="font-weight-bold mt-6"
            >
              <span class="font-weight-bold">フォローする</span>
            </v-btn>
          </template>
        </v-col>
      </v-row>
      <template v-if="isSelectTab">
        <UserTopics />
      </template>
      <template v-else>
        <PublicRelations 
        :user="user"
        :userPR="userPR"
      />
      </template>
    </v-container>
  </v-row>
</template>
<script>
import UserTopics from '../organisms/UserTopics';
import PublicRelations from '../organisms/PublicRelations';

export default {
  name: 'UserInfo',
  components: {
    UserTopics,
    PublicRelations,
  },
  data() {
    return {
      drawer: true,
      loading: true,
      user: {
        icon_url: '',
        name: '',
        introduction_text: '',
        user_code: '',
      },
      favorited: false,
      topics: {},
      is_auth: false,
      total_count: null,
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL,
      userFavoritedLoading: false,
      isSelectTab: true,
      userPR: {
        user_characters: [],
        user_languages: [],
        user_tools: [],
      },
      favoriteBtnColor: "#5E00BC",
      favoriteBtnOutLine: true,
    }
  },
  computed: {
    isFavorited: function() {
      return this.favorited
    },
    isMyPage: function() {
      return this.getUserCode === this.$route.params.user_code;
    },
    isAuth() {
      return this.is_auth
    },
    isExistTopic() {
      return this.total_count > 0;
    },
    icon: function() {
      return this.user.icon_url
    },
    getUserCode: function() {
      return this.$store.getters['auth/isUserCode']
    },
  },
  methods: {
    // お気に入り
    userFavorite() {
      this.userFavoritedLoading = true;
      if(this.favorited){
        this.$store.dispatch('favorite/userDelete', this.user.user_code)
          .then(() => {
            this.favorited = false;
            this.userFavoritedLoading = false;
            this.favoriteBtnColor = "#5E00BC";
            this.favoriteBtnOutLine = true;
          })
      } else {
        this.$store.dispatch('favorite/userRegister', this.user.user_code)
          .then(() => {
            this.favorited = true;
            this.userFavoritedLoading = false;
            this.favoriteBtnColor = "#D0D0D0";
            this.favoriteBtnOutLine = false;
          })
      }
    },
    setPublicRelationsTab() {
      this.isSelectTab = false
    },
    setUserTopicsTab() {
      this.isSelectTab = true
    }
  },
  watch: {
    async $route(to, from) {
      // ルートの変更の検知...
      if (to.params !== from.params) {
        // 初期化
        this.loading = true;
        // TODO: コンフリクト回避のためそのままだが、methodに切り分ける
        // TODO: 下の階層でもAPI通信しているためpropsとして渡す
        if(this.isMyPage) {
          this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/profile')
            .then(response => {
              this.user = response.data
              this.loading = false;
              this.total_count = this.user.topics.length;
              this.is_auth = true
              this.$store.dispatch('favorite/users')
                .then(response => {
                  response.map(user => {
                    if(this.user.user_code === user.user_code) {
                      this.favorited = true;
                    }
                  })
                  this.isDisabled = false;
                })
            });
        } else {
          this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/' + this.$route.params.user_code)
            .then(response => {
              this.user = response.data
              this.loading = false;
              this.total_count = this.user.topics.length;
              if(this.getUserCode) {
                this.is_auth = true
                this.$store.dispatch('favorite/users')
                  .then(response => {
                    response.map(user => {
                      if(this.user.user_code === user.user_code) {
                        this.favorited = true;
                      }
                    })
                    this.isDisabled = false;
                  })
              }
            });
        }
        this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/appeal/' + this.$route.params.user_code)
          .then(response => {
            // 取得できた場合は上書き
            this.userPR = response.data;
          }).catch((error) => {
            // 取得できない場合はエラーを潰す
            console.log(error.response.data);
          });
          }
        }
  },
  created: function () {
    if(this.isMyPage) {
      this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/profile')
        .then(response => {
          this.user = response.data
          this.loading = false;
          this.total_count = this.user.topics.length;
          this.is_auth = true
          this.$store.dispatch('favorite/users')
            .then(response => {
              response.map(user => {
                if(this.user.user_code === user.user_code) {
                  this.favorited = true;
                }
              })
            })
        });
    } else {
      this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/' + this.$route.params.user_code)
        .then(response => {
          this.user = response.data
          this.loading = false;
          this.total_count = this.user.topics.length;
          if(this.getUserCode) {
            this.is_auth = true
            this.$store.dispatch('favorite/users')
              .then(response => {
                response.map(user => {
                  if(this.user.user_code === user.user_code) {
                    this.favorited = true;
                  }
                })
              })
          }
        });
    }
    this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/appeal/' + this.$route.params.user_code)
      .then(response => {
        // 取得できた場合は上書き
        this.userPR = response.data;
      }).catch((error) => {
        // 取得できない場合はエラーを潰す
        console.log(error.response.data);
      });
  },
};
</script>
